import React from "react";

/**
 * Filter controls for the import set. Filters set each file's `include` flag
 * live (see applyFiltersToTree); manual per-row toggles then fine-tune until the
 * next filter change. Library-duplicate detection is opt-in (it hashes files),
 * surfaced as a button rather than running automatically on a 1000-file drop.
 */
const ImportFilterBar = ({ counts, filters, onChange, onCheckDuplicates, dupChecking, dupCount, disabled }) => {
    const categories = Object.keys(counts).sort();

    const toggleCategory = (cat) => {
        const next = new Set(filters.categories);
        if (next.has(cat)) next.delete(cat);
        else next.add(cat);
        onChange({ ...filters, categories: next });
    };

    return (
        <div className="iw-filterbar">
            <div className="iw-filter-group iw-filter-types">
                {categories.map((cat) => (
                    <label key={cat} className={`iw-chip-toggle ${filters.categories.has(cat) ? "on" : ""}`}>
                        <input
                            type="checkbox"
                            checked={filters.categories.has(cat)}
                            onChange={() => toggleCategory(cat)}
                            disabled={disabled}
                        />
                        {cat} <span className="iw-count">{counts[cat]}</span>
                    </label>
                ))}
            </div>

            <div className="iw-filter-group">
                <input
                    type="search"
                    className="iw-filter-name"
                    placeholder="Filter by name…"
                    value={filters.name}
                    onChange={(e) => onChange({ ...filters, name: e.target.value })}
                    disabled={disabled}
                />
                <input
                    type="number"
                    className="iw-filter-size"
                    min="0"
                    placeholder="min MB"
                    value={filters.minMB}
                    onChange={(e) => onChange({ ...filters, minMB: e.target.value })}
                    disabled={disabled}
                />
                <input
                    type="number"
                    className="iw-filter-size"
                    min="0"
                    placeholder="max MB"
                    value={filters.maxMB}
                    onChange={(e) => onChange({ ...filters, maxMB: e.target.value })}
                    disabled={disabled}
                />
            </div>

            <div className="iw-filter-group">
                <label
                    className={`iw-chip-toggle ${filters.excludeDuplicates ? "on" : ""}`}
                    title={dupCount == null ? "Run a duplicate check first" : `${dupCount} duplicate(s) found`}
                >
                    <input
                        type="checkbox"
                        checked={filters.excludeDuplicates}
                        onChange={(e) => onChange({ ...filters, excludeDuplicates: e.target.checked })}
                        disabled={disabled || dupCount == null}
                    />
                    Exclude duplicates {dupCount != null && <span className="iw-count">{dupCount}</span>}
                </label>
                <button
                    type="button"
                    className="iw-text-btn"
                    onClick={onCheckDuplicates}
                    disabled={disabled || dupChecking}
                >
                    {dupChecking ? "Checking…" : "Check library for duplicates"}
                </button>
            </div>
        </div>
    );
};

export default ImportFilterBar;
